
import { useSelector } from 'react-redux';
import './App.css';

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Dashboard from './component/Dashboard';
import DefaultLayout from './component/DefaultLayout';
import GuestLayout from './component/GuestLayout';
import Login from './component/Login';
import NotAuthorized from './component/NotAuthorized';
import NotFound from './component/NotFound';
import Signup from './component/Signup';
import AdminDashboard from './component/admin/AdminDashboard';
import AdminLayout from './component/admin/AdminLayout';
import NewUser from './component/admin/users/newuser';
import AdminProfile from './component/admin/profile/AdminProfile';
import Users from './component/admin/users/Users';
import UserDashboard from './component/user/UserDashboard';
import UserLayout from './component/user/UserLayout';
import UserProfile from './component/user/profile/UserProfile';

import Orders from './component/user/order/orders';
import Products from './component/user/product/products';

import { default as AdminProducts } from './component/admin/product/products';
import ProductTypes from './component/admin/producttype/producttypes';
import NewProduct from './component/admin/product/newproduct';
import NewProductType from './component/admin/producttype/newproducttype';
import Error from './component/error';
import Logs from './component/admin/log/logs';
import Files from './component/admin/files/files';
import Favorites from './component/user/favorite/favorites';


function App() {

  let token = useSelector(state => state.user.token);

  return <BrowserRouter>
    <Routes>

      <Route path="/" element={<DefaultLayout />}>
        <Route index element={token ? <Dashboard /> : <Navigate to='/login' />} />

        <Route path='/admin' element={<AdminLayout />} >
          <Route index element={token ? <AdminDashboard /> : <Navigate to='/' />} />
          <Route path='/admin/users' element={token ? <Users /> : <Navigate to='/' />} />
          <Route path='/admin/users/:id' element={token ? <Users /> : <Navigate to='/' />} />
          <Route path='/admin/profile' element={token ? <AdminProfile /> : <Navigate to='/' />} />
          <Route path='/admin/user' element={token ? <NewUser /> : <Navigate to='/' />} />
          <Route path='/admin/products' element={token ? <AdminProducts /> : <Navigate to='/' />} />
          <Route path='/admin/products/:id' element={token ? <AdminProducts /> : <Navigate to='/' />} />
          <Route path='/admin/producttypes' element={token ? <ProductTypes /> : <Navigate to='/' />} />
          <Route path='/admin/producttypes/:id' element={token ? <ProductTypes /> : <Navigate to='/' />} />
          <Route path='/admin/product' element={token ? <NewProduct /> : <Navigate to='/' />} />
          <Route path='/admin/producttype' element={token ? <NewProductType /> : <Navigate to='/' />} />
          <Route path='/admin/logs' element={token ? <Logs /> : <Navigate to='/' />} />
          <Route path='/admin/files' element={token ? <Files /> : <Navigate to='/' />} />
        </Route>

        <Route path='/' element={<UserLayout />} >
          <Route index element={token ? <UserDashboard /> : <Navigate to='/' />} />
          <Route path='/profile' element={token ? <UserProfile /> : <Navigate to='/' />} />
          <Route path='/orders' element={token ? <Orders /> : <Navigate to='/' />} />
          <Route path='/products' element={token ? <Products /> : <Navigate to='/' />} />
          <Route path='/products/:id' element={token ? <Products /> : <Navigate to='/' />} />
          <Route path='/favorites' element={token ? <Favorites /> : <Navigate to='/' />} />

        </Route>

      </Route>

      <Route path='/' element={<GuestLayout />} >
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
      </Route>

      <Route path='*' element={<NotFound />} />
      <Route path='/401' element={<NotAuthorized />} />
      <Route path='/error/:message' element={<Error />} />

    </Routes>
  </BrowserRouter>
}

export default App;
